export function validateEmail (email) {
  // eslint-disable-next-line max-len, no-useless-escape
  return /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(email);
};

export function validatePhone (inputValue) {
  // eslint-disable-next-line max-len, no-unused-expressions, no-useless-escape
  return inputValue.length === 11 && /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(inputValue);
};

export function applyPhoneInputMask (e) {
  const x = e.target.value
    .replace(/\+1|\D/g, '')
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  e.target.value = `+1${x[1] ? `( ${x[1]} ) ` : ''}${x[2]}${
    x[3] ? ` - ${x[3]}` : ''
  }`;
};
